<h2 mat-dialog-title class="mb-3">
  <span class="d-flex align-items-center gap-3">
    Prima di continuare
    <mat-icon>policy</mat-icon>
  </span>
</h2>

<mat-dialog-content>
  <p>
    Per continuare ad utilizzare l'app devi prendere visione ed accettare la nostra
    <a [href]="cookiePolicyUrl" target="_blank" rel="noopener">Cookie Policy</a>
    e i
    <a [href]="termsUrl" target="_blank" rel="noopener">Termini e Condizioni</a>.
  </p>

  <mat-checkbox [formControl]="accepted" color="primary">
    Ho letto e accetto Cookie Policy e Termini e Condizioni *
  </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top">
  <button mat-stroked-button color="warn" (click)="logout()">
    <mat-icon>logout</mat-icon>
    Esci
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="confirm()"
    [disabled]="accepted.invalid">
    <mat-icon>check_circle</mat-icon>
    Accetto e continuo
  </button>
</mat-dialog-actions>
